import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { useSelector } from './hooks/useSelector';

export type SelectDialogDialogProps = {
    onConfirm: (data) => void;
    onClose: () => void;
    open: boolean;
    title: string;
    menu: Array<any>;
} & DefaultComponentProps;

export const SelectDialog = ({ open, title, menu, onConfirm, onClose }: SelectDialogDialogProps) => {
    const { onHandleChange, selected } = useSelector(open)
   
    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant='h2'>{title}</Typography>
            </DialogTitle>
            <DialogContent>
                <FlexGrid container spacing={2} fullWidth>
                    <FormControl color='secondary' fullWidth>
                        <InputLabel>Tipo</InputLabel>
                        <Select value={selected || '-1'} onChange={onHandleChange.bind(this)} label='Tipo' color='secondary' MenuProps={{style: {zIndex: 35001}}} >
                            <MenuItem value={'-1'} disabled>Tipo</MenuItem>
                            {menu.map((item, index) => {
                                return item.name !== 'reboot' && <MenuItem key={`type-${index}`} value={item.name}>{item.title}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </FlexGrid>
            </DialogContent>
            <DialogActions>
                <FlexGrid fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px', display: 'flex' }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button disabled={selected ? false : true} onClick={() => onConfirm(selected)} size='normal'>
                            Aceptar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}